import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./QuoteChatTab.css";
import { getQuoteChatCountAPI } from "../../../utils/APIs/chatApis";
import Loader from "../../../Loader/Loader";

const LIMIT = 10;

const QuoteChatTab = () => {
  const navigate = useNavigate();

  const [quotes, setQuotes] = useState([]);
  const [page, setPage] = useState(() => {
    const saved = sessionStorage.getItem("quoteChatPage");
    return saved ? Number(saved) : 1;
  });
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  // const fetchQuotesChat = async (pageNumber = page) => {
  //   try {
  //     setLoading(true);

  //     const res = await getQuoteChatCountAPI(pageNumber, LIMIT);

  //     if (res?.data?.success) {
  //       setQuotes(res.data.data || []);
  //       setTotal(res.data.meta?.total || 0);
  //       setPage(res.data.meta?.page || pageNumber);
  //     }
  //   } catch (err) {
  //     console.error("Quote chat fetch failed", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Save page in session
useEffect(() => {
  const fetchQuotesChat = async (pageNumber = page) => {
    try {
      setLoading(true);

      const res = await getQuoteChatCountAPI(pageNumber, LIMIT);

      if (res?.data?.success) {
        setQuotes(res.data.data || []);
        setTotal(res.data.meta?.total || 0);
        setPage(res.data.meta?.page || pageNumber);
      }
    } catch (err) {
      console.error("Quote chat fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  // initial load
  fetchQuotesChat(page);

  // polling
  const interval = setInterval(() => {
    fetchQuotesChat(page);
  }, 10000);

  return () => clearInterval(interval);
}, [page]);

  // Initial load + 10 sec polling
  useEffect(() => {
  const fetchQuotesChat = async (pageNumber = page) => {
    try {
      setLoading(true);

      const res = await getQuoteChatCountAPI(pageNumber, LIMIT);

      if (res?.data?.success) {
        setQuotes(res.data.data || []);
        setTotal(res.data.meta?.total || 0);
        setPage(res.data.meta?.page || pageNumber);
      }
    } catch (err) {
      console.error("Quote chat fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  // initial load
  fetchQuotesChat(page);

  // polling
  const interval = setInterval(() => {
    fetchQuotesChat(page);
  }, 10000);

  return () => clearInterval(interval);
}, [page]);
  // useEffect(() => {
  //   fetchQuotesChat(page);

  //   const interval = setInterval(() => {
  //     fetchQuotesChat(page);
  //   }, 10000);

  //   return () => clearInterval(interval);
  // }, [page]);

  const handleChatClick = (quote) => {
    navigate(`/chat/quote/${quote.id}`);
  };

  const totalPages = Math.ceil(total / LIMIT);

  return (
    <div className="table-wrapper">
      <table className="bookings-table">
        <thead>
          <tr>
            <th className="td-sr">Sr.</th>
            <th>Quote Name</th>
            <th>Event Type</th>
            <th>Event Date</th>
            <th>Location</th>
            <th>Budget</th>
            <th>Chat</th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan="7" className="no-data"><Loader/></td>
            </tr>
          ) : quotes.length === 0 ? (
            <tr>
              <td colSpan="7" className="no-data">No Quotes Found</td>
            </tr>
          ) : (
            quotes.map((item, index) => (
              <tr key={item.id}>
                <td className="td-sr">{(page - 1) * LIMIT + index + 1}</td>

                <td>{item.name || "-"}</td>

                <td>{item.eventType || "-"}</td>

                <td>
                  {item.startDate
                    ? new Date(item.startDate).toLocaleDateString("en-IN")
                    : "-"}
                </td>

                <td>{item.eventLocation || "-"}</td>

                <td>{item.budget || "-"}</td>

                <td>
                  <div
                    className="chat-btn chat-icon-wrapper"
                    onClick={() => handleChatClick(item)}
                  >
                    💬

                    {item.unreadMessages > 0 && (
                      <span className="chat-badge">
                        {item.unreadMessages}
                      </span>
                    )}
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Pagination */}
      {total > LIMIT && (
        <div className="pagination">
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          <span className="pagination-info">
            Page {page} of {totalPages}
          </span>

          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default QuoteChatTab;